import { render, staticRenderFns } from "./LightProgram.vue?vue&type=template&id=1fc38814&"
import script from "./LightProgram.vue?vue&type=script&lang=js&"
export * from "./LightProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports